import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  AbstractServerInteractionService,
  combineHeadersOptions,
  commonErrorHandlingDisabled,
  globalLoadingDisabled,
} from '../abstract/abstract.server.interaction.service';
import { Observable } from 'rxjs';
import { AppService } from '../../../../app.service';

export interface IDriverLicenseResponse {
  status: number;
  isSubmitted: boolean;
}

@Injectable()
export class DriverLicenseService extends AbstractServerInteractionService {
  protected get url() {
    return {
      driverLicense: this.appService.getApiUrls().driverLicense,
      governmentId: this.appService.getApiUrls().governmentId
    };
  }

  constructor(protected appService: AppService,
              protected http: HttpClient) {
    super();
  }

  public confirmDriverLicense({ firstPhotoBase64, secondPhotoBase64 }: {
    firstPhotoBase64: string,
    secondPhotoBase64: string,
  }): Observable<IDriverLicenseResponse | any> {
    const cutBase64 = (img: string) => img && img.split ? img.split(',')[1] : '';

    return this.http.post(this.url.driverLicense, {
      firstPhoto: cutBase64(firstPhotoBase64),
      secondPhoto: cutBase64(secondPhotoBase64)
    });
  }

  public confirmDocuments({ firstPhotoBase64, secondPhotoBase64, documentType }: {
    firstPhotoBase64: string,
    secondPhotoBase64: string,
    documentType: string,
  }): Observable<IDriverLicenseResponse | any> {
    const cutBase64 = (img: string) => img && img.split ? img.split(',')[1] : '';

    return this.http.post(this.url.governmentId, {
      firstPhoto: cutBase64(firstPhotoBase64),
      secondPhoto: cutBase64(secondPhotoBase64),
      documentType
    });
  }

  public confirmDocumentsByAgreementKey(
    publicKey: string,
    {
      firstPhotoBase64,
      secondPhotoBase64,
      documentType,
    }: {
    firstPhotoBase64: string,
    secondPhotoBase64: string,
    documentType: string,
  }): Observable<IDriverLicenseResponse | any> {
    const cutBase64 = (img: string) => img && img.split ? img.split(',')[1] : '';

    return this.http.post(`${this.url.governmentId}/${publicKey}`, {
      firstPhoto: cutBase64(firstPhotoBase64),
      secondPhoto: cutBase64(secondPhotoBase64),
      documentType
    }, {
      headers: combineHeadersOptions(globalLoadingDisabled, commonErrorHandlingDisabled)
    });
  }
}
